import React from 'react';

import { CompanyContact } from '_lib/api/apiTypes.shim';
import { Markup } from '_lib/components/Markup/Markup';
import { Stack } from '_lib/components/Stack/Stack';
import { HeaderBox } from '_lib/featureComponents/HeaderBox/HeaderBox';
import { HeaderTextBlock } from '_lib/featureComponents/HeaderTextBlock/HeaderTextBlock';
import { formatPhone } from '_lib/utils/helpers';

export interface FormattedContactBlockProps {
  contact: Partial<CompanyContact> | null;
}

export const FormattedContactBlock = (props: FormattedContactBlockProps): React.ReactElement => {
  const { contact } = props;
  if (!contact) return <>N/A</>;

  const lines = [];
  if (contact.role) lines.push(contact.role);
  if (contact.phoneNumber) lines.push(formatPhone(contact.phoneNumber));
  if (contact.email) lines.push(contact.email);

  const text = lines.join('\n');

  // If we have no values to display, return N/A (similar to above if !contact)
  if (!contact.name && !text && !contact.notes) return <>N/A</>;

  return (
    <Stack spacing={2}>
      <HeaderTextBlock headerText={contact.name || 'Unknown Name'} text={text} defaultTextValue='' />
      {contact.notes && (
        <HeaderBox headerText='Contact Instructions'>
          <Markup
            typographyProps={{ sx: { whiteSpace: 'pre-line', overflowWrap: 'break-word' } }}
            content={contact.notes}
          />
        </HeaderBox>
      )}
    </Stack>
  );
};
